// Set the min attribute of the date input to the current date
document.addEventListener("DOMContentLoaded", (event) => {
  const form = document.querySelector(".calcForm");
  const aside = document.querySelector(".calculatorResults");
  const formBtn = document.querySelector(".calcSubmit");
  const maintenance = document.querySelector(".calcResultsHead");
  const warning = document.querySelector(".warning");
  const macroButtonCtn = document.querySelector(".macroOptions");
  const customSection = document.querySelector(".customMacrosCtn");

  const protein = document.querySelector("#proteinMacro");
  const carb = document.querySelector("#carbMacro");
  const fat = document.querySelector("#fatMacro");
  const proteinFlex = document.querySelector("#proteinFlex");
  const carbFlex = document.querySelector("#carbFlex");
  const fatFlex = document.querySelector("#fatFlex");
  const proteinInput = document.querySelector("#protein");
  const carbInput = document.querySelector("#carb");
  const fatInput = document.querySelector("#fat");
  let TDEE = 0;
  let WT = 0;

  let previousFormData = {};

  formBtn.addEventListener("click", (e) => {
    e.preventDefault();

    const formData = {
      age: form.querySelector("#age").value,
      feet: form.querySelector("#feet").value,
      inches: form.querySelector("#inches").value,
      weight: form.querySelector("#weight").value,
      gender: form.querySelector("#gender").value,
      act: form.querySelector("#activity").value,
    };
    const nDate = new Date();
    const curDate = getCurrentDate();

    // Check if the form data has changed
    if (JSON.stringify(formData) === JSON.stringify(previousFormData)) {
      console.log("Data has not changed.");
      return; // Exit early if data hasn't changed
    }

    // Update the previous form data
    previousFormData = { ...formData };

    const startBMR = calculateTDEE(
      formData.age,
      heightToInches(formData.feet, formData.inches),
      formData.weight,
      formData.gender
    );
    WT = formData.weight;
    TDEE = calculateTotalExpenditure(startBMR, formData.act, 0);

    initBMR(TDEE, formData.weight);

    aside.classList.add("active");
    aside.parentElement.classList.add("active");
  });

  [...macroButtonCtn.children].forEach((button, bIndex) => {
    button.addEventListener("click", (e) => {
      [...macroButtonCtn.children].forEach((btn, bcIndex) => {
        if (bcIndex === bIndex) {
          btn.classList.add("selected");
        } else {
          btn.classList.remove("selected");
        }
      });
      toggleBalance(button.getAttribute("data-type"), TDEE);
    });
  });

  function updateMacroRows(p, c, f) {
    protein.querySelector("h3").querySelector("span").innerHTML = p;
    carb.querySelector("h3").querySelector("span").innerHTML = c;
    fat.querySelector("h3").querySelector("span").innerHTML = f;
    proteinFlex.querySelector("span").innerHTML = p;
    carbFlex.querySelector("span").innerHTML = c;
    fatFlex.querySelector("span").innerHTML = f;

    protein
      .querySelector(".macroTotalCalories")
      .querySelector("span").innerHTML = p * 4;
    carb.querySelector(".macroTotalCalories").querySelector("span").innerHTML =
      c * 4;
    fat.querySelector(".macroTotalCalories").querySelector("span").innerHTML =
      f * 9;
  }

  function balancedMacros(TDEE) {
    hideCustom();

    const pt = parseFloat(WT);
    const remainder = TDEE - pt * 4;
    const cb = Math.floor((remainder * 0.6) / 4);
    const ft = Math.floor((remainder * 0.4) / 9);

    updateMacroRows(pt, cb, ft);
    maintenance.querySelector("span").innerHTML = Math.round(TDEE);
  }
  function highProteinMacro(TDEE) {
    hideCustom();

    const pt = parseFloat(WT) * 1.2;
    const remainder = TDEE - pt * 4;
    const cb = Math.floor((remainder * 0.6) / 4);
    const ft = Math.floor((remainder * 0.4) / 9);

    updateMacroRows(pt, cb, ft);

    maintenance.querySelector("span").innerHTML = Math.round(TDEE);
  }
  function lowFatMacro(TDEE) {
    hideCustom();

    const pt = parseFloat(WT);
    const remainder = TDEE - pt * 4;
    const cb = Math.floor((remainder * 0.8) / 4);
    const ft = Math.floor((remainder * 0.2) / 9);

    updateMacroRows(pt, cb, ft);

    maintenance.querySelector("span").innerHTML = Math.round(TDEE);
  }
  function lowCarbMacro(TDEE) {
    hideCustom();
    const pt = parseFloat(WT);
    const remainder = TDEE - pt * 4;
    const cb = Math.floor((remainder * 0.3) / 4);
    const ft = Math.floor((remainder * 0.7) / 9);

    updateMacroRows(pt, cb, ft);

    maintenance.querySelector("span").innerHTML = Math.round(TDEE);
  }

  function toggleBalance(type = "balance", TDEE) {
    switch (type) {
      case "balanced":
        balancedMacros(TDEE);
        break;
      case "hp":
        highProteinMacro(TDEE);
        break;
      case "lf":
        lowFatMacro(TDEE);
        break;
      case "lc":
        lowCarbMacro(TDEE);
        break;
      case "custom":
        init(TDEE);
        showCustom();
        break;
    }
  }

  function hideCustom() {
    customSection.classList.remove("active");
  }
  function showCustom() {
    customSection.classList.add("active");
  }

  function initBMR(BMR, wt) {
    init(BMR);

    const pt = parseFloat(wt);
    const remainder = BMR - pt * 4;
    const cb = Math.floor((remainder * 0.6) / 4);
    const ft = Math.floor((remainder * 0.4) / 9);

    updateMacroRows(pt, cb, ft);

    maintenance.querySelector("span").innerHTML = Math.round(BMR);
  }

  proteinInput.addEventListener("input", (e) => {
    balance(TDEE, "p");
  });
  carbInput.addEventListener("input", (e) => {
    balance(TDEE, "c");
  });
  fatInput.addEventListener("input", (e) => {
    balance(TDEE, "f");
  });

  function init(TDEE) {
    const maxP = Math.floor(TDEE / 4);
    const maxC = Math.floor(TDEE / 4);
    const maxF = Math.floor(TDEE / 9);

    proteinInput.max = maxP;
    carbInput.max = maxC;
    fatInput.max = maxF;
  }

  function balance(totalCalories, inp = "p") {
    const proteinCalories = parseInt(proteinInput.value);
    const carbCalories = parseInt(carbInput.value);
    const fatCalories = parseInt(fatInput.value);

    const calorieDelta =
      totalCalories -
      (proteinCalories * 4 + carbCalories * 4 + fatCalories * 9);

    switch (inp) {
      case "p":
        proteinInner(carbCalories, fatCalories, calorieDelta);
        break;

      case "c":
        carbInner(proteinCalories, fatCalories, calorieDelta);
        break;
      case "f":
        fatInner(proteinCalories, carbCalories, calorieDelta);

        break;
    }

    updateMacros();

    // console.log(
    //   parseInt(proteinInput.value) * 4 +
    //     parseInt(carbInput.value) * 4 +
    //     parseInt(fatInput.value) * 9
    // );
  }
  function updateMacros() {
    protein.querySelector("h3").querySelector("span").innerHTML =
      proteinInput.value;
    carb.querySelector("h3").querySelector("span").innerHTML = carbInput.value;
    fat.querySelector("h3").querySelector("span").innerHTML = fatInput.value;
    protein
      .querySelector(".macroTotalCalories")
      .querySelector("span").innerHTML = proteinInput.value * 4;
    carb.querySelector(".macroTotalCalories").querySelector("span").innerHTML =
      carbInput.value * 4;
    fat.querySelector(".macroTotalCalories").querySelector("span").innerHTML =
      fatInput.value * 9;
    proteinFlex.querySelector("span").innerHTML = proteinInput.value;
    carbFlex.querySelector("span").innerHTML = carbInput.value;
    fatFlex.querySelector("span").innerHTML = fatInput.value;
  }

  function proteinInner(carb, fat, delta) {
    if (carb > 1) {
      carbInput.value = carb + Math.floor(delta / 4);
    } else {
      fatInput.value = fat + Math.floor(delta / 9);
    }
  }
  function carbInner(protein, fat, delta) {
    if (protein > 1) {
      proteinInput.value = protein + Math.floor(delta / 4);
    } else {
      fatInput.value = fat + Math.floor(delta / 9);
    }
  }
  function fatInner(protein, carb, delta) {
    if (protein > 1) {
      proteinInput.value = protein + Math.floor(delta / 4);
    } else {
      carbInput.value = carb + Math.floor(delta / 4);
    }
  }

  function heightToInches(feet, inches) {
    return Number(feet) * 12 + Number(inches);
  }
  function lbsToKg(pounds) {
    return pounds * 0.453592;
  }
  function roundToNearest(number) {
    return number;
    // return Math.round(number / 25) * 25;
  }
  function inchesToCm(inches) {
    return inches * 2.54;
  }
  function calculateTDEE(age, heightInInches, weightInLbs, gender) {
    let weightInKg = lbsToKg(weightInLbs);

    let heightInCm = inchesToCm(heightInInches);

    let tdee;
    if (gender === "male") {
      tdee = 10 * weightInKg + 6.25 * heightInCm - 5 * age + 5;
    } else {
      tdee = 10 * weightInKg + 6.25 * heightInCm - 5 * age - 161;
    }

    return tdee;
  }
  function showWarning(message) {
    warning.innerHTML = message;
    warning.style.display = "block";
  }
  function hideWarning() {
    warning.style.display = "none";
  }
  function getCurrentDate() {
    let today = new Date();
    let year = today.getFullYear();
    let month = (today.getMonth() + 1).toString().padStart(2, "0");
    let day = today.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  function daysBetweenDates(date1, date2) {
    // Parse the dates using the Date constructor
    let d1 = new Date(date1);
    let d2 = new Date(date2);

    // Calculate the time difference in milliseconds
    let timeDifference = d2 - d1;

    // Convert time difference from milliseconds to days
    let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    return daysDifference;
  }

  function calculateTotalExpenditure(BMR, activity, deficit) {
    const ABAValue = BMR * 0.1875;
    const delt = 0.9;
    const tot = BMR + ABAValue * (1.0 + (delt * activity) / 5);
    const defTEF = (tot - deficit) * 0.1;
    return Math.trunc(tot - deficit + defTEF);
  }

  function handleIntakePlan() {}
});
